/**
 * Magnetic Buttons
 */

import {ScrollTrigger} from 'gsap/all';

export function initOtros () {

  function handleAccordionClick () {
    // Función para abrir el primer acordeón automáticamente
    function openFirstAccordion () {
      const $firstHeader = $ ('.accordion-header').first ();
      const $firstBody = $firstHeader.next ('.accordion-body');

      if (!$firstHeader.hasClass ('active')) {
        $firstHeader.addClass ('active');
        $firstBody.addClass ('active').show ();
        // Al añadir la clase "active", el CSS dispara la animación del SVG
      }
    }

    // Ejecutar al cargar
    openFirstAccordion ();

    // Click en el Header
    $ ('.accordion-header').on ('click', function () {
      const $header = $ (this);
      const $body = $header.next ('.accordion-body');
      const isActive = $header.hasClass ('active');

      if (!isActive) {
        // Cerrar otros
        $ ('.accordion-header').not ($header).removeClass ('active');
        $ ('.accordion-body').not ($body).slideUp (300).removeClass ('active');

        // Abrir este
        $header.addClass ('active');
        $body.slideDown (300, function () {
          $body.addClass ('active'); // Dispara animación SVG
        });
      } else {
        // Cerrar este
        $body.removeClass ('active'); // El SVG se "desdibuja" por CSS
        // Esperamos un poco a que la animación del SVG progrese antes de ocultar
        setTimeout (() => {
          $header.removeClass ('active');
          $body.slideUp (300);
        }, 300);
      }
    });

    // Botón cerrar interno
    $ ('.accordion-close').on ('click', function (e) {
      e.preventDefault ();
      const $body = $ (this).closest ('.accordion-body');
      const $header = $body.prev ('.accordion-header');

      $body.removeClass ('active');
      setTimeout (() => {
        $header.removeClass ('active');
        $body.slideUp (300);
      }, 300);
    });
  }
  handleAccordionClick ();

  ///////////////////////////////////////

  const mobileBtn = document.getElementById ('toggle-sidebar-mobile');
  const menuContainer = document.querySelector ('.accordion-menu');
  if (mobileBtn && menuContainer) {
    mobileBtn.addEventListener ('click', function () {
      menuContainer.classList.toggle ('is-visible-mobile');

      // Cambiar el texto o signo del botón
      const span = this.querySelector ('span');
      if (menuContainer.classList.contains ('is-visible-mobile')) {
        span.textContent = '-';
      } else {
        span.textContent = '+';
      }
    });
  }
  if (menuContainer) {
    menuContainer.addEventListener ('click', function (e) {
      if (e.target.classList.contains ('toggle-btn')) {
        e.preventDefault ();
        const btn = e.target;
        const parentLi = btn.closest ('.item-nivel');
        const subMenu = parentLi.querySelector ('.sub-menu-accordion');
        const isOpening =
          subMenu.style.display === 'none' || subMenu.style.display === '';

        if (isOpening) {
          // --- Lógica de Colapso (Cerrar hermanos) ---
          const siblings = parentLi.parentElement.querySelectorAll (
            ':scope > .item-nivel.is-open'
          );
          siblings.forEach (sibling => {
            if (sibling !== parentLi) {
              sibling.classList.remove ('is-open');
              const siblingMenu = sibling.querySelector ('.sub-menu-accordion');
              const siblingBtn = sibling.querySelector ('.toggle-btn');
              if (siblingMenu) siblingMenu.style.display = 'none';
              if (siblingBtn) siblingBtn.textContent = '+';
            }
          });

          // Abrir el actual
          subMenu.style.display = 'block';
          parentLi.classList.add ('is-open');
          btn.textContent = '-';
        } else {
          // Cerrar el actual
          subMenu.style.display = 'none';
          parentLi.classList.remove ('is-open');
          btn.textContent = '+';
        }
      }
      setTimeout (() => {
        ScrollTrigger.refresh ();
      }, 300);
    });
  }

  ///////////////////////
  const toggle = document.querySelector ('.idiomas .click-dropdown');
  const menu = document.querySelector ('.idiomas .dropdown-menu');

  if (toggle && menu) {
    // Abrir / Cerrar al hacer clic en el idioma activo
    toggle.addEventListener ('click', function (e) {
      e.stopPropagation ();
      const isVisible = menu.style.display === 'block';
      menu.style.display = isVisible ? 'none' : 'block';
      toggle.classList.toggle ('active');
    });

    // Cerrar el menú si el usuario hace clic en cualquier otra parte de la pantalla
    document.addEventListener ('click', function () {
      menu.style.display = 'none';
      toggle.classList.remove ('active');
    });
  }
  ///////////////////////
  var shareButtons = document.querySelectorAll ('.share-btn');

  if (shareButtons) {
    [].forEach.call (shareButtons, function (button) {
      button.addEventListener ('click', function (event) {
        var width = 650, height = 450;

        event.preventDefault ();

        window.open (
          this.href,
          'Share Dialog',
          'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' +
            width +
            ',height=' +
            height +
            ',top=' +
            (screen.height / 1.5 - height / 1.5) +
            ',left=' +
            (screen.width / 1.5 - width / 1.5)
        );
      });
    });
  }

  //https://api.whatsapp.com/send?text=". window.location.href
  var URLactual = 'https://api.whatsapp.com/send?text=' + window.location.href;
  //alert(URLactual);

  $ ('#wsp-share').attr ('href', URLactual);

  document.querySelectorAll ('.copy-link-btn').forEach (function (btn) {
    btn.addEventListener ('click', function (e) {
      e.preventDefault ();
      const url = this.dataset.url;
      navigator.clipboard
        .writeText (url)
        .then (function () {
          alert ('Enlace copiado al portapapeles');
        })
        .catch (function (err) {
          const textArea = document.createElement ('textarea');
          textArea.value = url;
          document.body.appendChild (textArea);
          textArea.select ();
          document.execCommand ('copy');
          document.body.removeChild (textArea);
          alert ('Enlace copiado al portapapeles');
        });
    });
  });
}

export function productQuantity () {
  $ (document).on ('click', '.qty-btn.plus', function () {
    let input = $ (this).siblings ('.qty');
    input.val (parseInt (input.val ()) + 1).trigger ('change');
  });
  $ (document).on ('click', '.qty-btn.minus', function () {
    let input = $ (this).siblings ('.qty');
    let value = parseInt (input.val ());
    if (value > 1) {
      input.val (value - 1).trigger ('change');
    }
  });
  $ (document).on ('change', '.qty', function () {
    let qty = $ (this).val ();
    $ (this)
      .closest ('.product-actions')
      .find ('.add_to_cart_button')
      .attr ('data-quantity', qty);
  });

  $ (
    document.body
  ).on ('click', '.quantity .increase, .quantity .decrease', function (e) {
    e.preventDefault ();
    var $this = $ (this),
      $qty = $this.siblings ('.qty'),
      current = parseInt ($qty.val (), 10),
      min = parseInt ($qty.attr ('min'), 10),
      max = parseInt ($qty.attr ('max'), 10);
    min = min ? min : 1;
    max = max ? max : current + 1;
    if ($this.hasClass ('decrease') && current > min) {
      $qty.val (current - 1);
      $qty.trigger ('change');
    }
    if ($this.hasClass ('increase') && current < max) {
      $qty.val (current + 1);
      $qty.trigger ('change');
    }
  });
  $ ('.woocommerce-message .close').click (function () {
    $ (this).parent ().fadeOut ();
  });

  //bc.checkBox = function () {
  $ ('#ship-to-different-address')
    .find ('.input-checkbox')
    .on ('change', function () {
      if ($ (this).is (':checked')) {
        $ (this).parent ().find ('.checkbox').addClass ('checked');
      } else {
        $ (this).parent ().find ('.checkbox').removeClass ('checked');
      }
    })
    .trigger ('change');
  var afield = '#requirements_field';
  $ ('input#checkbox_msg').change (function () {
    if ($ (this).is (':checked')) $ (afield).show ();
    else $ (afield).hide ();
  });
  $ ('#cuit_field').hide ();
  $ ('#dni_cuil_field').hide ();
  $ ('#tipo_persona').on ('change', function () {
    if ($ ('#tipo_persona').val () == 'juridica') {
      $ ('#cuit_field').show ();
    } else {
      $ ('#cuit_field').hide ();
    }
    if ($ ('#tipo_persona').val () == 'fisica') {
      $ ('#dni_cuil_field').show ();
    } else {
      $ ('#dni_cuil_field').hide ();
    }
  });
  //bc.focusInputs = function () {
  $ ('.woocommerce-account, .woocommerce-checkout')
    .on ('focus', '.input-text', function () {
      $ (this).closest ('.form-row').addClass ('active');
    })
    .on ('focusout', '.input-text', function () {
      if ($ (this).val () == '') {
        $ (this).closest ('.form-row').removeClass ('active');
      }
    })
    .find ('.input-text')
    .each (function () {
      if ($ (this).val () != '') {
        $ (this).closest ('.form-row').addClass ('active');
      }
    });
  $ ('#commentform')
    .on ('focus', ':input', function () {
      $ (this).closest ('p').addClass ('active');
    })
    .on ('focusout', ':input', function () {
      if ($ (this).val () == '') {
        $ (this).closest ('p').removeClass ('active');
      }
    })
    .find (':input')
    .each (function () {
      if ($ (this).val () != '') {
        $ (this).closest ('p').addClass ('active');
      }
    });
}
